<template>
  <div :class="wrapperClasses">
    <slot/>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
/**
 * Blog List Component
 *
 * A versatile list component for MDC (Markdown Components) that supports both
 * ordered and unordered lists with consistent styling.
 * Usage in markdown: ::blog-list{type="ul"} or ::blog-list{type="ol"}
 */

interface Props {
  /**
   * Type of list to render
   */
  type?: 'ul' | 'ol';
}

const props = withDefaults(defineProps<Props>(), {
  type: 'ul',
});

// Wrapper styling classes that will style nested lists
const wrapperClasses = computed(() => {
  const baseClasses = 'my-4 text-foreground/80';

  if (props.type === 'ol') {
    return `${baseClasses} [&_ol]:list-decimal [&_ol]:list-outside [&_ol]:pl-6 [&_ol]:space-y-1.5 [&_ol_li]:leading-7 [&>ol]:list-decimal [&>ol]:list-outside [&>ol]:pl-6 [&>ol]:space-y-1.5`;
  }

  return `${baseClasses} [&_ul]:list-disc [&_ul]:list-outside [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_ul_li]:leading-7 [&>ul]:list-disc [&>ul]:list-outside [&>ul]:pl-6 [&>ul]:space-y-1.5`;
});
</script>
